import { Box, Typography, useTheme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { BatchNotSelected } from './components/BatchNotSelected';
import { EncounterStatisticsTable } from './components/EncounterStatsComponents/EncounterStatisticsTable';
import { MetricProjectsDropdown } from './components/MetricProjectsDropdown';
import { ProjectNotSelected } from './components/ProjectNotSelected';
import { useMetricEncounterStats } from './useMetricEncounterStats';
import Dropdown from '../../wrapper-components/Dropdown/Dropdown';

export const MetricEncounterStats = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const {
    encounterStatsDateRange,
    isEncounterStatsDateRangeLoading,
    startDate,
    endDate,
    handleChangeStartDate,
    handleChangeEndDate,
    shouldDisableStartDate,
    batchTypeOptions,
    batchTypeId,
    isMetricsBatchTypeListLoading,
    handleBatchTypeChange,
    projectId,
  } = useMetricEncounterStats();

  return (
    <Box
      sx={{ p: theme.spacing(6), display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
    >
      <Box sx={{ mb: theme.spacing(12) }}>
        <Typography variant="h4">
          {formatMessage({ id: 'metrics.encounterStats.title' })}
        </Typography>
      </Box>
      <MetricProjectsDropdown />
      <Box
        id="metrics-encounter-stats-content"
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
      >
        <Box sx={{ display: 'flex', gap: theme.spacing(6) }}>
          <DatePicker
            label={formatMessage({ id: 'metrics.dashboard.batchProgress.datepicker.label.start' })}
            value={startDate}
            onChange={(newValue) => handleChangeStartDate(newValue)}
            minDate={dayjs(encounterStatsDateRange?.minDate)}
            maxDate={endDate ?? undefined}
            disabled={isEncounterStatsDateRangeLoading || !projectId || !batchTypeId}
            shouldDisableDate={shouldDisableStartDate}
            slotProps={{
              textField: {
                sx: {
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                },
              },
            }}
          />
          <DatePicker
            label={formatMessage({ id: 'metrics.dashboard.batchProgress.datepicker.label.end' })}
            value={endDate}
            onChange={(newValue) => handleChangeEndDate(newValue)}
            minDate={startDate ?? undefined}
            maxDate={dayjs(encounterStatsDateRange?.maxDate)}
            disabled={isEncounterStatsDateRangeLoading || !projectId || !batchTypeId}
            slotProps={{
              textField: {
                sx: {
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                },
              },
            }}
          />
          <Dropdown
            id="metric-encounter-stats-batch-type-dropdown"
            options={batchTypeOptions}
            onChange={handleBatchTypeChange}
            label={formatMessage({ id: 'workspaceCommon.content.dropdown.batch.label' })}
            placeholder={formatMessage({
              id: 'workspaceCommon.content.dropdown.batch.placeholder',
            })}
            disabled={isMetricsBatchTypeListLoading || batchTypeOptions.length === 0 || !projectId}
            width="medium"
            value={batchTypeId ?? ''}
          />
        </Box>
        <Box>
          {!projectId ? (
            <ProjectNotSelected />
          ) : !batchTypeId ? (
            <BatchNotSelected />
          ) : (
            <EncounterStatisticsTable />
          )}
        </Box>
      </Box>
    </Box>
  );
};
